(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-tab"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.custom-tab');
    const tabContents = document.querySelectorAll('.custom__tab-content');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const contentId = this.dataset.contentId;
        const content = document.getElementById(contentId);

        // Xóa class active của tất cả các tab và content
        tabContents.forEach(function (c) {
          c.classList.remove('active');
        });

        tabs.forEach(function (t) {
          t.classList.remove('active');
        });

        // Thêm class active cho tab và content được click
        this.classList.add('active');
        content.classList.add('active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
